// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--pqBSq","main":"a10a3f92e9--main--LR0um","trend":"a10a3f92e9--trend--qApSw","inc":"a10a3f92e9--inc--m8kCs"};